module.exports = __webpack_public_path__ + "img/thumbnail_RedNeckedWallaby_f_normal.2e79c858.png";